export default "__VITE_ASSET__CX0JV10U__"